<div class="border-b border-zinc-300">
  <kendo-panelbar [animate]="false">
    <kendo-panelbar-item data-testid="umc-user-role-button" title="Item 1">
      <ng-template kendoPanelBarItemTitle>
        <p data-testid="umc-user-role-title">{{ userRoleToggleSettings().title }}</p>
      </ng-template>
      <ng-template kendoPanelBarContent>
        <div class="flex flex-col gap-2 p-4 text-[12px] text-gray-500">
          @if (isThereAdminRole()) {
            <div data-testid="umc-user-list-role-admin" class="flex flex-col gap-2">
              @for (role of userRoleToggleSettings().adminRoleItems; track role.text) {
                <p>{{ role.text }}</p>
              }
            </div>
            @if (userRoleToggleSettings().simpleRoleItems.length > 0) {
              <hr />
            }
          }
          <div data-testid="umc-user-list-role-simple" class="flex flex-col gap-2">
            @for (role of userRoleToggleSettings().simpleRoleItems; track role.text) {
              <p>{{ role.text }}</p>
            }
          </div>
        </div>
      </ng-template>
    </kendo-panelbar-item>
  </kendo-panelbar>
</div>
